// import logo from './logo.svg'
import 'tailwindcss/tailwind.css';
import './App.css';
import AppRouter from "./config/AppRouter";
import { BrowserRouter as Router, useNavigate } from "react-router";
import Sidebar from './Components/Sidebar';
import { setNavigator } from './store/useAuthStore';
import React, { useEffect } from 'react';
import './lib/axiosInterceptor.js';
import { Toaster } from 'react-hot-toast';


function InitNavigator() {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigator(navigate);
  }, [navigate]);

  return null;
}



function App() {
  const pathname = window.location.pathname;

  return (
    <Router base='/lifeline_admin'>
      <InitNavigator />
      <Toaster position="bottom-center" />
      <AppRouter />
    </Router>
  );
}

export default App;
